import { assoc, propOr } from 'ramda'
import { useEffect, useState } from 'react'

import useProgramRegistrations, {
  withProgramRegistrationsStore,
} from '@/app/dashboard/events/stores/use-program-registrations'
import Link from '@/components/link'
import DashboardLinks from '@/config/dashboard-links'
import protectedRoute from '@/utils/protected-route'

const registrationsSelector = propOr([], 'registrations')
const Links = () => {
  const registrations = useProgramRegistrations(registrationsSelector)
  const [loading, setloading] = useState(true)
  useEffect(() => {
    const timeout = setTimeout(() => setloading(false), 3000)
    return () => clearTimeout(timeout)
  }, [loading, registrations])
  return (
    <div className='flex flex-wrap items-stretch justify-between'>
      {loading && (
        <div className='flex w-full items-center justify-center'>
          <div role='status'>
            <svg
              aria-hidden='true'
              className='mr-2 h-8 w-8 animate-spin fill-blue-600 text-gray-200 dark:text-gray-600'
              viewBox='0 0 100 101'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                fill='currentColor'
              />
              <path
                d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                fill='currentFill'
              />
            </svg>
            <span className='sr-only'>Loading...</span>
          </div>
        </div>
      )}
      {!loading &&
        (registrations.length ? (
          <div className='mb-8 flex w-full flex-wrap text-[16px]'>
            <p className='overflow-hidden text-ellipsis'>
              Congratulations on registering for the Thrive Skills:{' '}
              {Object.values(
                registrations.reduce((acc, current) => {
                  if (
                    current.program.id &&
                    current.registrationOption.schedule.length
                  ) {
                    return assoc(current.program.id, current, acc)
                  }
                  return acc
                }, {}),
              )
                .map((reg) =>
                  reg.registrationOption.schedule.length
                    ? reg.program.title
                    : '',
                )
                .filter(Boolean)
                .join(', ')}
              !
            </p>
            <p>
              This is an integrated learning platform where you can attend LIVE
              classes, revisit the videos of previous classes, make private
              notes in your journal and keep track of your goals.
            </p>
            <p>
              Watch demo video in{' '}
              <Link
                href='/dashboard/overview'
                noUnderline
                className='text-[#f59175]'
              >
                (link to demo video)
              </Link>
            </p>
          </div>
        ) : (
          <div className='flex h-[150px] w-full flex-wrap text-[10px] sm:text-[15px]'>
            <p className='w-full text-[15px] sm:text-[20px]'>
              Here is your Thrive Skill Dashboard!
            </p>
            <p>
              You will find everything you need on the courses that you register
              here!
            </p>
          </div>
        ))}
      {DashboardLinks.map((link) => (
        <div
          key={link.route}
          className='mb-8 flex w-[47%] flex-col justify-between rounded-lg border border border-theme-orange'
        >
          <Link
            href={link.route}
            noUnderline
            className='flex h-full flex-wrap content-between'
          >
            <div className='z-10 -mb-[25px] w-full pt-[12.5px] text-center '>
              <p className='font-medium sm:text-2xl'>{link.name}</p>
              <p className='px-5 text-xs font-light sm:text-lg'>{link.desc}</p>
            </div>
            <img
              className='inline-block aspect-1 w-full flex-1 rounded-lg object-contain px-5'
              src={link.icon.src}
              alt={link?.name}
              style={{ objectPosition: link.objectPosition }}
            />
          </Link>
        </div>
      ))}
    </div>
  )
}

export default protectedRoute(withProgramRegistrationsStore(Links))
